
<div class="blog-details" *ngIf="blog">
    <div class="date">{{ blog.created  | date:'MMMM d, y' }}</div>
    <div class="title">{{ blog.name }}</div>
    <div class="author">Author: {{ blog.authorName }}</div>
    <div class="description" [innerHTML]="blog.postBody"></div>    
</div>
